import { render, staticRenderFns } from "./examGradeModal.vue?vue&type=template&id=faaaa6d6"
import script from "./examGradeModal.vue?vue&type=script&lang=js"
export * from "./examGradeModal.vue?vue&type=script&lang=js"
import style0 from "./examGradeModal.vue?vue&type=style&index=0&id=faaaa6d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports